import config from 'config'
import {
  isObject,
  isEmptyString,
  isEmptyObject,
  isUrl,
  isUrlScheme,
  isNumber,
  isNumberString
} from 'lib/detectType'

const commonValidate = params => {
  const errors = []
  if (isEmptyString(params.pfId) && isEmptyString(params.pfGroupId)) {
    errors.push({
      bmsTplChannel: {
        message: `템플릿을 등록할 채널 혹은 채널 그룹을 선택해주세요.`
      }
    })
  }
  if (isEmptyString(params?.name)) {
    errors.push({
      bmsTplChannel: { message: `템플릿 이름을 입력해주세요.` }
    })
  } else if (params?.name?.length > 200) {
    errors.push({
      bmsTplChannel: {
        message: `템플릿 이름은 최대 200자까지 입력할 수 있습니다.\n(현재 ${params?.name?.length}자)`
      }
    })
  }
  errors.push(...couponValidate(params))
  return errors
}

const couponValidate = ({ needHighlight = true, label = '', coupon }) => {
  const errors = []
  if (!isObject(coupon) || isEmptyObject(coupon)) {
    return []
  }
  if (isEmptyString(coupon?.title)) {
    errors.push(
      needHighlight
        ? { bmsTplCoupon: { message: `${label} 쿠폰 이름을 입력해주세요.` } }
        : `${label} 쿠폰 이름을 입력해주세요.`
    )
  }
  if (isEmptyString(coupon?.description)) {
    errors.push(
      needHighlight
        ? { bmsTplCoupon: { message: `${label} 쿠폰 설명을 입력해주세요.` } }
        : `${label} 쿠폰 설명을 입력해주세요.`
    )
  }
  if (isEmptyString(coupon?.linkMobile)) {
    errors.push(
      needHighlight
        ? { bmsTplCoupon: { message: `${label} 쿠폰 링크를 입력해주세요.` } }
        : `${label} 쿠폰 링크를 입력해주세요.`
    )
  }
  if (!isEmptyString(coupon?.linkMobile) && !isUrl(coupon?.linkMobile)) {
    errors.push(
      needHighlight
        ? {
            bmsTplCoupon: {
              message: `${label} 쿠폰 모바일 링크가 올바르지 않습니다.`
            }
          }
        : `${label} 쿠폰 모바일 링크가 올바르지 않습니다.`
    )
  }
  if (!isEmptyString(coupon?.linkPc) && !isUrl(coupon?.linkPc)) {
    errors.push(
      needHighlight
        ? {
            bmsTplCoupon: {
              message: `${label} 쿠폰 데스크탑 링크가 올바르지 않습니다.`
            }
          }
        : `${label} 쿠폰 데스크탑 링크가 올바르지 않습니다.`
    )
  }
  if (
    !isEmptyString(coupon?.linkAndroid) &&
    !isUrlScheme(coupon?.linkAndroid)
  ) {
    errors.push(
      needHighlight
        ? {
            bmsTplCoupon: {
              message: `${label} 쿠폰 안드로이드 링크가 올바르지 않습니다.`
            }
          }
        : `${label} 쿠폰 안드로이드 링크가 올바르지 않습니다.`
    )
  }
  if (!isEmptyString(coupon?.linkIos) && !isUrlScheme(coupon?.linkIos)) {
    errors.push(
      needHighlight
        ? {
            bmsTplCoupon: {
              message: `${label} 쿠폰 아이폰 링크가 올바르지 않습니다.`
            }
          }
        : `${label} 쿠폰 아이폰 링크가 올바르지 않습니다.`
    )
  }
  return errors
}

const contentValidate = ({
  chatBubbleType,
  head = false,
  label = '템플릿 내용',
  content,
  needHighlight = true
}) => {
  const errors = []
  const maxLength = {
    TEXT: { length: 1300, newLine: 99 },
    IMAGE: { length: 400, newLine: 29 },
    WIDE: { length: 76, newLine: 1 },
    CAROUSEL_FEED: { length: head ? 50 : 180, newLine: head ? 2 : 33 },
    CAROUSEL_COMMERCE: { length: head ? 50 : 180, newLine: head ? 2 : 33 },
    PREMIUM_VIDEO: { length: 76, newLine: 1 }
  }
  if (isEmptyString(content)) {
    const message = `${label}을 입력해주세요.`
    errors.push(needHighlight ? { bmsTplContent: { message } } : message)
  } else if (
    maxLength?.[chatBubbleType]?.newLine > -1 &&
    content.replace(/[^\n]/g, '').length > maxLength?.[chatBubbleType]?.newLine
  ) {
    const message = `${label}의 줄바꿈은 최대 ${maxLength?.[chatBubbleType]?.newLine}번까지 입력할 수 있습니다.`
    errors.push(needHighlight ? { bmsTplContent: { message } } : message)
  }
  if (content?.length > maxLength?.[chatBubbleType]?.length) {
    const message = `${label}은 최대 ${maxLength?.[chatBubbleType]?.length}자까지 입력할 수 있습니다.\n(현재 ${content.length}자)`
    errors.push(needHighlight ? { bmsTplContent: { message } } : message)
  }
  return errors
}

const imageValidate = ({
  label,
  fileData,
  fileValidationResult,
  imageLink,
  needHighlight = true
}) => {
  const errors = []
  if (isEmptyString(fileData)) {
    errors.push(
      needHighlight
        ? { bmsTplImage: { message: `${label} 이미지를 선택해주세요.` } }
        : `${label} 이미지를 선택해주세요.`
    )
  }
  if (!isEmptyString(imageLink)) {
    if (!isUrl(imageLink)) {
      const message = `${label} 이미지 링크가 올바르지 않습니다.`
      errors.push(needHighlight ? { bmsTplImage: { message } } : message)
    }
    if (imageLink.length > 100) {
      const message = `${label} 이미지 링크는 최대 100자까지 입력할 수 있습니다.\n(현재 ${imageLink.length}자)`
      errors.push(needHighlight ? { bmsTplImage: { message } } : message)
    }
  }
  if (
    fileValidationResult?.length > 0 &&
    fileValidationResult.find(data => data?.isValid === false)
  ) {
    fileValidationResult
      .filter(data => data?.isValid === false)
      .map(data => {
        errors.push(
          needHighlight
            ? { bmsTplImage: { message: `${label} - ${data?.errorMessage}` } }
            : `${label} - ${data?.errorMessage}`
        )
      })
  }
  return errors
}

const buttonsValidate = ({
  needHighlight = true,
  label = '',
  chatBubbleType,
  buttons = [],
  coupon
}) => {
  const errors = []
  if (chatBubbleType === 'TEXT' || chatBubbleType === 'IMAGE') {
    if (isObject(coupon) && buttons?.length > 5) {
      const message = `${label} ${
        config.messageTypeInfo[`bms_${String(chatBubbleType).toLowerCase()}`]
          ?.name
      } 템플릿의 버튼은 최대 5개까지 추가할 수 있습니다.`
      errors.push(needHighlight ? { bmsTplButtons: { message } } : message)
    }
    if (isObject(coupon) && !isEmptyObject(coupon) && buttons?.length > 4) {
      const message = `${label} 쿠폰 입력 시 텍스트형 템플릿의 버튼은 최대 4개까지 추가할 수 있습니다.`
      errors.push(needHighlight ? { bmsTplButtons: { message } } : message)
    }
  }
  if (chatBubbleType === 'WIDE' && buttons?.length > 2) {
    const message = `${label} 와이드형 템플릿의 버튼은 최대 2개까지 추가할 수 있습니다.`
    errors.push(needHighlight ? { bmsTplButtons: { message } } : message)
  }
  if (
    chatBubbleType === 'CAROUSEL_FEED' ||
    chatBubbleType === 'CAROUSEL_COMMERCE' ||
    chatBubbleType === 'COMMERCE'
  ) {
    if (buttons?.length < 1) {
      const message = `${label} ${
        config.messageTypeInfo[`bms_${String(chatBubbleType).toLowerCase()}`]
          ?.name
      } 템플릿의 버튼은 최소 1개이상 추가해야합니다.`
      errors.push(needHighlight ? { bmsTplButtons: { message } } : message)
    }
    if (buttons?.length > 2) {
      const message = `${label} ${
        config.messageTypeInfo[`bms_${String(chatBubbleType).toLowerCase()}`]
          ?.name
      } 템플릿의 버튼은 최대 2개까지 추가할 수 있습니다.`
      errors.push(needHighlight ? { bmsTplButtons: { message } } : message)
    }
  }
  if (chatBubbleType === 'WIDE_ITEM_LIST' && buttons?.length > 2) {
    const message = `${label} 와이드리스트형 템플릿의 버튼은 최대 2개까지 추가할 수 있습니다.`
    errors.push(needHighlight ? { bmsTplButtons: { message } } : message)
  }
  if (chatBubbleType === 'PREMIUM_VIDEO' && buttons?.length > 1) {
    const message = `${label} 프리미엄 비디오 템플릿의 버튼은 최대 1개까지 추가할 수 있습니다.`
    errors.push(needHighlight ? { bmsTplButtons: { message } } : message)
  }
  if (buttons?.length > 0) {
    buttons.forEach((button, index) => {
      if (isEmptyString(button?.name)) {
        const message = `${label} ${index + 1}번 버튼 이름을 입력해주세요.`
        errors.push(needHighlight ? { bmsTplButtons: { message } } : message)
      } else if (button?.name?.length > 14) {
        const message = `${label} ${
          index + 1
        }번 버튼 이름은 최대 14자까지 입력할 수 있습니다.\n(현재 ${
          button?.name?.length
        }자)`
        errors.push(needHighlight ? { bmsTplButtons: { message } } : message)
      }
      if (
        (chatBubbleType === 'COMMERCE' ||
          chatBubbleType === 'CAROUSEL_FEED' ||
          chatBubbleType === 'CAROUSEL_COMMERCE') &&
        button?.linkType !== 'WL' &&
        button?.linkType !== 'AL'
      ) {
        const message = `${label} ${
          index + 1
        }번 버튼 - 커머스, 캐러셀커머스형 템플릿은 웹링크, 앱링크 버튼만 입력 가능합니다.`
        errors.push(needHighlight ? { bmsTplButtons: { message } } : message)
      }
      if (button?.linkType === 'WL' || button?.linkType === 'AL') {
        errors.push(
          ...linkValidate({
            label: `${label} ${index + 1}번 버튼`,
            needHighlight,
            ...button
          })
        )
      }
    })
  }
  return errors
}

const textTypeValidate = params => {
  const errors = []
  errors.push(...contentValidate({ ...params }))
  errors.push(...buttonsValidate({ ...params }))
  return errors
}

const imageTypeValidate = params => {
  const errors = []
  errors.push(...contentValidate({ ...params }))
  errors.push(...imageValidate({ label: '', ...params }))
  errors.push(...buttonsValidate({ ...params }))
  return errors
}

const wideItemListTypeValidate = (params, formData) => {
  const { slideIndex } = formData
  const errors = []
  if (isEmptyString(params?.header)) {
    const message = `메인 아이템 헤더를 입력해주세요.`
    errors.push(slideIndex === 0 ? { bmsTplContent: { message } } : message)
  } else if (params?.header?.length > 20) {
    const message = `메인 아이템 헤더는 최대 20자까지 입력할 수 있습니다.\n(현재 ${params?.header?.length}자)`
    errors.push(slideIndex === 0 ? { bmsTplContent: { message } } : message)
  }
  if (!isEmptyString(params?.mainWideItem?.title)) {
    if (params?.mainWideItem?.title?.length > 25) {
      const message = `메인 아이템 제목은 최대 25자까지 입력할 수 있습니다.\n(현재 ${params?.mainWideItem?.title?.length}자)`
      errors.push(slideIndex === 0 ? { bmsTplWideItem: { message } } : message)
    }
    if (params?.mainWideItem?.title.replace(/[^\n]/g, '').length > 1) {
      const message = `메인 아이템 제목의 줄바꿈은 최대 1번까지 입력할 수 있습니다.\n(현재 ${
        params?.mainWideItem?.title?.replace(/[^\n]/g, '').length
      }번)`
      errors.push(slideIndex === 0 ? { bmsTplWideItem: { message } } : message)
    }
  }
  errors.push(
    ...imageValidate({
      label: `메인 아이템`,
      needHighlight: slideIndex === 0,
      fileData: params?.mainWideItem?.fileData,
      fileValidationResult: params?.mainWideItem?.fileValidationResult
    })
  )
  errors.push(...buttonsValidate({ ...params }))
  errors.push(
    ...linkValidate({
      label: `메인 아이템`,
      needHighlight: slideIndex === 0,
      linkMobile: params?.mainWideItem?.linkMobile,
      linkPc: params?.mainWideItem?.linkPc,
      linkAndroid: params?.mainWideItem?.linkAndroid,
      linkIos: params?.mainWideItem?.linkIos
    })
  )
  if (params?.subWideItemList?.length < 2) {
    const message = `서브 아이템을 최소 2개 이상 추가해주세요.`
    errors.push(slideIndex === 0 ? { bmsTplSlide: { message } } : message)
  } else {
    params.subWideItemList.forEach((item, index) => {
      if (isEmptyString(item?.title)) {
        const message = `${index + 1}번 서브 아이템 제목을 입력해주세요.`
        errors.push(
          slideIndex !== 0 ? { bmsTplWideItem: { message } } : message
        )
      } else {
        if (item?.title?.length > 20) {
          const message = `${
            index + 1
          }번 서브 아이템 제목은 최대 20자까지 입력할 수 있습니다.\n(현재 ${
            item?.title?.length
          }자)`
          errors.push(
            slideIndex !== 0 ? { bmsTplWideItem: { message } } : message
          )
        }
        if (item.title.replace(/[^\n]/g, '').length > 1) {
          const message = `${
            index + 1
          }번 서브 아이템 제목의 줄바꿈은 최대 1번까지 입력할 수 있습니다.\n(현재 ${
            item?.title?.replace(/[^\n]/g, '').length
          }번)`
          errors.push(
            slideIndex !== 0 ? { bmsTplWideItem: { message } } : message
          )
        }
      }
      errors.push(
        ...imageValidate({
          label: `${index + 1}번 서브 아이템`,
          needHighlight: slideIndex === index,
          fileData: item?.fileData,
          fileValidationResult: item?.fileValidationResult
        })
      )
      errors.push(
        ...linkValidate({
          label: `${index + 1}번 서브 아이템`,
          needHighlight: slideIndex === index,
          linkMobile: item?.linkMobile,
          linkPc: item?.linkPc,
          linkAndroid: item?.linkAndroid,
          linkIos: item?.linkIos
        })
      )
      errors.push(
        ...buttonsValidate({
          ...item,
          needHighlight: slideIndex === index,
          chatBubbleType: params?.chatBubbleType
        })
      )
    })
  }
  return errors
}

const carouselFeedTypeValidate = (params, formData) => {
  const { slideIndex } = formData
  const errors = []
  if (params.carousel?.list?.length < 2) {
    const message = `캐러셀 피드 슬라이드를 최소 2개 이상 추가해주세요.`
    errors.push({ bmsTplSlide: { message } })
  } else {
    params.carousel.list.forEach((item, index) => {
      if (isEmptyString(item?.header)) {
        const message = `${index + 1}번 슬라이드 헤더를 입력하세요.`
        errors.push(
          slideIndex === index ? { bmsTplContent: { message } } : message
        )
      } else if (item?.header?.length > 20) {
        const message = `${
          index + 1
        }번 슬라이드 헤더는 최대 20자까지 입력할 수 있습니다.\n(현재 ${
          item?.header?.length
        }자)`
        errors.push(
          slideIndex === index ? { bmsTplContent: { message } } : message
        )
      }
      errors.push(
        ...contentValidate({
          label: `${index + 1}번 슬라이드 내용`,
          ...item
        })
      )
      errors.push(
        ...imageValidate({
          label: `${index + 1}번 슬라이드`,
          needHighlight: slideIndex === index,
          ...item
        })
      )
      errors.push(
        ...buttonsValidate({
          ...item,
          needHighlight: slideIndex === index,
          chatBubbleType: params?.chatBubbleType
        })
      )
      errors.push(
        ...couponValidate({
          label: `${index + 1}번 슬라이드`,
          needHighlight: slideIndex === index,
          ...item
        })
      )
      if (
        !isEmptyString(item?.additionalContent) &&
        item?.additionalContent.length > 34
      ) {
        const message = `${
          index + 1
        }번 슬라이드 추가 내용은 최대 34자까지 입력할 수 있습니다.`
        errors.push(
          slideIndex === index ? { bmsTplContent: { message } } : message
        )
      }
      if (item?.buttons?.length < 1) {
        const message = `${
          index + 1
        }번 슬라이드 버튼을 최소 1개 이상 추가해주세요.`
        errors.push(
          slideIndex === index ? { bmsTplButtons: { message } } : message
        )
      }
    })
  }
  if (isObject(params?.carousel?.tail)) {
    errors.push(
      ...linkValidate({
        label: '더 보기 클릭 시',
        linkMobile: params?.carousel?.tail?.linkMobile,
        linkPc: params?.carousel?.tail?.linkPc,
        linkAndroid: params?.carousel?.tail?.linkAndroid,
        linkIos: params?.carousel?.tail?.linkIos
      })
    )
  }
  return errors
}

const commerceValidate = commerce => {
  const errors = []
  if (!isObject(commerce)) {
    errors.push({ bmsTplCommerce: { message: `상품 정보를 입력해주세요.` } })
  }
  if (isEmptyString(commerce?.title)) {
    errors.push({ bmsTplCommerce: { message: `상품 이름을 입력해주세요.` } })
  }
  const hasAllVars =
    commerce?.regularPrice === '#{정상가격}' &&
    commerce?.discountPrice === '#{할인가격}' &&
    (isEmptyString(commerce?.discountRate) ||
      commerce?.discountRate === '#{할인율}') &&
    (isEmptyString(commerce?.discountFixed) ||
      commerce?.discountFixed === '#{정액할인가격}')
  const hasAllNumbers =
    isNumberString(commerce?.regularPrice) &&
    isNumberString(commerce?.discountPrice) &&
    (isEmptyString(commerce?.discountRate) ||
      isNumberString(commerce?.discountRate)) &&
    (isEmptyString(commerce?.discountFixed) ||
      isNumberString(commerce?.discountFixed))
  if (!hasAllVars && !hasAllNumbers) {
    errors.push({
      bmsTplCommerce: {
        message: `커머스 정보는 모두 변수를 사용하거나, 모두 고정 값을 사용해야 합니다.`
      }
    })
  }
  if (
    !isEmptyString(commerce?.regularPrice) &&
    commerce.regularPrice !== '#{정상가격}' &&
    (!isNumber(commerce.regularPrice) ||
      commerce.regularPrice > 9999999 ||
      commerce.regularPrice < 0)
  ) {
    errors.push({
      bmsTplCommerce: { message: `정상 상품 가격이 올바르지 않습니다.` }
    })
  }
  if (
    !isEmptyString(commerce?.discountPrice) &&
    commerce.discountPrice !== '#{할인가격}' &&
    (!isNumber(commerce.discountPrice) ||
      commerce.discountPrice > 9999999 ||
      commerce.discountPrice < 0)
  ) {
    errors.push({
      bmsTplCommerce: { message: `할인 후 금액이 올바르지 않습니다.` }
    })
  }
  if (
    !isEmptyString(commerce?.discountRate) &&
    commerce.discountRate !== '#{할인율}' &&
    (!isNumber(commerce.discountRate) ||
      commerce.discountRate > 100 ||
      commerce.discountRate < 0)
  ) {
    errors.push({
      bmsTplCommerce: { message: `할인율이 올바르지 않습니다.` }
    })
  }
  if (
    !isEmptyString(commerce?.discountFixed) &&
    commerce.discountFixed !== '#{정액할인가격}' &&
    (!isNumber(commerce.discountFixed) ||
      commerce.discountFixed > 9999999 ||
      commerce.discountFixed < 0)
  ) {
    errors.push({
      bmsTplCommerce: { message: `할인금액이 올바르지 않습니다.` }
    })
  }
  return errors
}

const linkValidate = ({
  label,
  needHighlight = true,
  linkMobile,
  linkPc,
  linkAndroid,
  linkIos
}) => {
  const errors = []
  if (isEmptyString(linkMobile)) {
    const message = `${label} 모바일 링크를 입력하세요.`
    errors.push(needHighlight ? { bmsTplTail: { message } } : message)
  } else {
    if (!isUrl(linkMobile)) {
      const message = `${label} 모바일 링크가 올바르지 않습니다.`
      errors.push(needHighlight ? { bmsTplTail: { message } } : message)
    }
    if (linkMobile.length > 100) {
      const message = `${label} 모바일 링크는 최대 100자까지 입력할 수 있습니다.\n(현재 ${linkMobile.length}자)`
      errors.push(needHighlight ? { bmsTplTail: { message } } : message)
    }
  }
  if (!isEmptyString(linkPc)) {
    if (!isUrl(linkPc)) {
      const message = `${label} 데스크탑 링크가 올바르지 않습니다.`
      errors.push(needHighlight ? { bmsTplTail: { message } } : message)
    }
    if (linkPc.length > 100) {
      const message = `${label} 데스크탑 링크는 최대 100자까지 입력할 수 있습니다.\n(현재 ${linkPc.length}자)`
      errors.push(needHighlight ? { bmsTplTail: { message } } : message)
    }
  }
  if (!isEmptyString(linkAndroid)) {
    if (!isUrlScheme(linkAndroid)) {
      const message = `${label} 안드로이드 링크가 올바르지 않습니다.`
      errors.push(needHighlight ? { bmsTplTail: { message } } : message)
    }
    if (linkAndroid.length > 100) {
      const message = `${label} 안드로이드 링크는 최대 100자까지 입력할 수 있습니다.\n(현재 ${linkAndroid.length}자)`
      errors.push(needHighlight ? { bmsTplTail: { message } } : message)
    }
  }
  if (!isEmptyString(linkIos)) {
    if (!isUrlScheme(linkIos)) {
      const message = `${label} 아이폰 링크가 올바르지 않습니다.`
      errors.push(needHighlight ? { bmsTplTail: { message } } : message)
    }
    if (linkIos.length > 100) {
      const message = `${label} 아이폰 링크는 최대 100자까지 입력할 수 있습니다.\n(현재 ${linkIos.length}자)`
      errors.push(needHighlight ? { bmsTplTail: { message } } : message)
    }
  }
  return errors
}

const commerceTypeValidate = params => {
  const errors = []
  if (
    !isEmptyString(params?.additionalContent) &&
    params?.additionalContent.length > 34
  ) {
    errors.push({
      bmsTplContent: {
        message: `추가 내용은 최대 34자까지 입력할 수 있습니다.\n(현재 ${params?.additionalContent?.length}자)`
      }
    })
  }
  errors.push(
    ...imageValidate({
      label: '상품 이미지',
      fileData: params?.fileData,
      fileValidationResult: params?.fileValidationResult
    })
  )
  errors.push(...commerceValidate(params?.commerce))
  errors.push(...buttonsValidate({ ...params }))
  return errors
}

const findKeyPath = (object, targetKey = 'imageId') => {
  const paths = {}
  const findPaths = (obj, currentPath = '') => {
    if (obj && typeof obj === 'object') {
      Object.keys(obj).forEach(key => {
        const newPath = currentPath ? `${currentPath}.${key}` : key
        if (key === targetKey) {
          paths[newPath] = obj[key]
        } else if (obj[key] && typeof obj[key] === 'object') {
          findPaths(obj[key], newPath)
        }
      })
    }
  }
  findPaths(object)
  return paths
}

const carouselCommerceTypeValidate = (params, formData) => {
  const { slideIndex } = formData
  const errors = []
  if (isObject(params?.carousel?.head)) {
    if (isEmptyString(params?.carousel?.head?.header)) {
      const message = `메인 슬라이드 헤더를 입력하세요.`
      errors.push({ bmsTplContent: { message } })
    } else if (params?.carousel?.head?.header?.length > 20) {
      const message = `메인 슬라이드 헤더는 최대 20자까지 입력할 수 있습니다.`
      errors.push({ bmsTplContent: { message } })
    }
    errors.push(
      ...contentValidate({
        label: '메인 슬라이드 내용',
        head: true,
        needHighlight: slideIndex === 0,
        ...params?.carousel?.head
      })
    )
    errors.push(
      ...imageValidate({
        label: '메인 슬라이드',
        needHighlight: slideIndex === 0,
        ...params?.carousel?.head
      })
    )
    const imgDiffRatioList = Object.values(
      findKeyPath(formData, 'widthRatio')
    ).reduce((acc, curr) => {
      if (isNumber(curr) && acc.indexOf(curr) === -1) {
        return [...acc, curr]
      }
      return acc
    }, [])
    if (imgDiffRatioList?.length > 1) {
      errors.push({
        bmsTplImage: {
          message: `메인 슬라이드를 포함한 모든 슬라이드의 이미지 가로:세로 비율은 동일해야 합니다.`
        }
      })
    }
    if (!isEmptyString(params?.carousel?.head?.linkMobile)) {
      errors.push(
        ...linkValidate({
          label: '메인 슬라이드',
          needHighlight: slideIndex === 0,
          ...params?.carousel?.head
        })
      )
    }
  }
  if (params.carousel?.list?.length < 1) {
    const message = `메인 슬라이드 포함 슬라이드를 최소 2개 이상 추가해주세요.`
    errors.push({ bmsTplSlide: { message } })
  } else if (params.carousel?.list?.length > 5) {
    const message = `슬라이드를 최대 5개까지 추가할 수 있습니다.`
    errors.push({ bmsTplSlide: { message } })
  } else {
    params.carousel.list.forEach((item, index) => {
      if (item?.additionalContent?.length > 34) {
        const message = `${
          index + 1
        }번 슬라이드 추가 내용은 최대 34자까지 입력할 수 있습니다.\n(현재 ${
          item?.additionalContent?.length
        }자)`
        errors.push(
          slideIndex === index ? { bmsTplContent: { message } } : message
        )
      }
      errors.push(
        ...imageValidate({
          label: `${index + 1}번 슬라이드`,
          needHighlight: slideIndex === index,
          ...item
        })
      )
      errors.push(
        ...couponValidate({
          label: `${index + 1}번 슬라이드`,
          needHighlight: slideIndex === index,
          ...item
        })
      )
      errors.push(
        ...buttonsValidate({
          ...item,
          label: `${index + 1}번 슬라이드`,
          chatBubbleType: params?.chatBubbleType
        })
      )
    })
  }
  if (isObject(params?.carousel?.tail)) {
    errors.push(
      ...linkValidate({
        label: '더 보기 클릭 시',
        linkMobile: params?.carousel?.tail?.linkMobile,
        linkPc: params?.carousel?.tail?.linkPc,
        linkAndroid: params?.carousel?.tail?.linkAndroid,
        linkIos: params?.carousel?.tail?.linkIos
      })
    )
  }
  return errors
}

export function bmsTplParamsValidation(params, formData) {
  const errors = []
  const { chatBubbleType } = params
  errors.push(...commonValidate(params))
  if (chatBubbleType === 'TEXT') {
    errors.push(...textTypeValidate(params))
  }
  if (chatBubbleType === 'IMAGE' || chatBubbleType === 'WIDE') {
    errors.push(...imageTypeValidate(params))
  }
  if (chatBubbleType === 'WIDE_ITEM_LIST') {
    errors.push(...wideItemListTypeValidate(params, formData))
  }
  if (chatBubbleType === 'CAROUSEL_FEED') {
    errors.push(...carouselFeedTypeValidate(params, formData))
  }
  if (chatBubbleType === 'COMMERCE') {
    errors.push(...commerceTypeValidate(params))
  }
  if (chatBubbleType === 'CAROUSEL_COMMERCE') {
    errors.push(...carouselCommerceTypeValidate(params, formData))
  }

  // keyName별로 에러 메시지를 그룹화
  const groupedErrors = errors.reduce((acc, error) => {
    // error가 객체가 아닌 경우 건너뛰기
    if (!isObject(error)) {
      return acc
    }
    const keyName = Object.keys(error)[0]
    const message = error[keyName]?.message
    // message가 존재하지 않는 경우 건너뛰기
    if (!message) {
      return acc
    }
    if (acc[keyName]) {
      acc[keyName].message += '\n' + message
    } else {
      acc[keyName] = { message }
    }
    return acc
  }, {})

  const highlight = Object.keys(groupedErrors).map(keyName => ({
    [keyName]: groupedErrors[keyName]
  }))
  const messages = [
    ...new Set(
      errors
        .map(error =>
          isObject(error) ? Object.values(error)[0]?.message : error
        )
        .filter(Boolean)
    )
  ]
  return { highlight, messages }
}
export default bmsTplParamsValidation
